<script>
import Breadcrumbs from '@/components/MarketplaceComponents/Breadcrumbs.vue'
import PageTitle from '@/components/MarketplaceComponents/PageTitle.vue'
import ProductCard from '@/components/MarketplaceComponents/ProductCard'
import Pagination from '@/components/Pagination/Pagination.vue'
import StoreService from '@/services/StoreService'

export default {
  components: {
    ProductCard,
    Pagination,
    Breadcrumbs,
    PageTitle
  },

  async asyncData ({ $axios }) {
    try {
      const { data } = await StoreService.getMarketplaceProductsWithUserID($axios, 1, 12, undefined, true)

      const products = data?.data?.products
      const productsCount = +data?.data?.count

      return {
        products,
        productsCount
      }
    } catch {
      return {}
    }
  },

  data () {
    return {
      productsCount: 0,
      page: 1,
      pageSize: 12,
      products: undefined
    }
  },

  computed: {
    breadcrumbs () {
      return [
        { title: this.$t('marketplace'), to: '/marketplace' },
        { title: this.$t('bestsellersTitle') }
      ]
    },

    pagesCount () {
      if (!this.productsCount || this.productsCount === 0) {
        return 1
      }

      return Math.ceil(this.productsCount / this.pageSize)
    }
  },

  methods: {
    async loadProducts () {
      this.$nuxt?.$loading?.start?.()
      this.products = undefined

      try {
        const { data } = await StoreService.getMarketplaceProductsWithUserID(this.$axios, this.page, this.pageSize, undefined, true)

        this.products = data?.data?.products
        this.productsCount = +data?.data?.count
      } catch (e) {
        console.log(e)
      }

      this.$nuxt?.$loading?.finish?.()
    },

    changePerPage (value) {
      this.pageSize = value
      this.page = 1
      this.loadProducts()
    },

    pageChange (value) {
      this.page = value + 1
      this.loadProducts()
    }
  }
}
</script>

<template>
  <div :class="$style.page">
    <Breadcrumbs :list="breadcrumbs" />

    <div :class="$style.page__body">
      <PageTitle with-go-back go-back-path="/" :title="$t('bestsellersTitle')" />

      <div v-if="products" :class="$style.products">
        <div v-for="product in products" :key="product.id">
          <ProductCard :product="product" short />
        </div>
      </div>

      <Pagination
        :class="$style.pagination"
        :per-page="pageSize"
        :pages-count="pagesCount"
        :current-page="page - 1"
        @perPageChange="changePerPage"
        @pageChange="pageChange"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.page {
  width: 100%;

  &__body {
    padding: 16px;
  }
}

.search {
  background: $blue-grey80;
  position: sticky;
  top: 48px;
  padding: 10px 0;
  z-index: 1;

  @media (min-width: $breakpointTablet) {
    top: 78px;
  }
}

.products {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;
  margin-top: 24px;

  @media (min-width: $breakpointTablet) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: $breakpointDesktopWide) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 12px;
  }
}

.pagination {
  margin: 40px 0;
}
</style>
